import { inject, Injectable } from "@angular/core";
import { UrlService } from "../../../../environments/urlService";
import { HttpClient, HttpContext } from "@angular/common/http";
import { LoginDTO } from "../../login/login-component/dto/LoginDTO";
import { LoginDTORs } from "../../login/login-component/dto/LoginDTORs";
import { firstValueFrom, Observable } from "rxjs";
import { IS_SPINNER_ACTIVE } from "../../../util/interceptors";
import { SessionExpirationService } from "./session-expiration.service";
import { ResetAllDataService } from "./reset-all-data.service";
import { Router } from "@angular/router";

@Injectable({
  providedIn: 'root',
})
export class AuthBackendService {
  private readonly url: string;
  private urlService = inject(UrlService);
  private http = inject(HttpClient);
  private resetService = inject(ResetAllDataService);
  private router = inject(Router);

  constructor() {
    this.url = this.urlService.getModelsUrl();
  }

  sendMagicLink(data: LoginDTO): Observable<LoginDTORs> {
    return this.http.post<LoginDTORs>(this.url + 'login', data, {
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      withCredentials: true,
      responseType: 'json',
    });
  }

  checkTokenValidity(token: string): Observable<boolean> {
    return this.http.post<boolean>(this.url + 'login/verify-token/' + token, null, {
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      withCredentials: true,
      responseType: 'json',
    });
  }

  removeCookie(): Observable<void> {
    return this.http.post<void>(this.url + 'logout/cookies', null, {
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      withCredentials: true,
    });
  }

  async logout(): Promise<void> {
    SessionExpirationService.setSessionLeaderByLogout();
    await firstValueFrom(this.removeCookie());
    this.resetService.reset();
    await this.router.navigate(['/']);
  }

  getMaintenance(): Observable<boolean> {
    return this.http.get<boolean>(
      this.url + 'maintenance',
      { withCredentials: true, responseType: 'json' },
    );
  }
}
